import { HttpHandler } from '../../api/HttpHandler';
import { IPromotionalCode } from '../../pages/types';
import { environment } from '../../enviroments';
import { IntlShape } from 'react-intl';
import { backendErrorCodes } from '../../context/ToastContext/types';

export const attachPromoCodeToPaymentIntent = async (
  paymentIntentID: string,
  promotionalCode: string,
  intl: IntlShape
): Promise<[IPromotionalCode | null, string | null]> => {
  try {
    const { data: promoCodeData } = await HttpHandler<IPromotionalCode>({
      method: 'POST',
      url: `${environment.PAYMENTS_URL}/paymentIntent/promotional-code/${paymentIntentID}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        promotionalCode: promotionalCode.trim(),
      },
    });

    return [promoCodeData, null];
  } catch (error: any) {
    const errorCode = error.error as Partial<keyof typeof backendErrorCodes>;
    return [null, backendErrorCodes(intl)[errorCode]?.text || backendErrorCodes(intl)?.promocode_not_found?.text];
  }
};
